import { api } from 'api'
import { toaster } from 'uikit/Toaster'
import { useInfiniteQuery } from '@tanstack/react-query'
import { useState } from 'react'

export const useFetchFaqList = () => {
  const [params, setParams] = useState({})

  let list = []
  let lastPage

  const query = useInfiniteQuery({
    queryKey: ['faqList', params],
    queryFn: ({ pageParam = 0 }) => {
      return api.faq.fetchList({ page: pageParam, size: 20, ...params })
    },
    initialPageParam: 0,
    getNextPageParam: ({ number }) => number + 1,
  })

  if (query.isError) {
    toaster.create({
      type: 'error',
      title: 'Произошла ошибка при загрузки faq списка',
      description: query.error?.message,
    })
  }

  if (query.data?.pages) {
    const content = query.data.pages.reduce((acc, item) => [...acc, ...item.content], [])
    list = content?.length ? content : []
    lastPage = query.data.pages[query.data.pages.length - 1]
  }

  return {
    fetch: setParams,
    list,
    hasMore: !lastPage?.last,
    ...query,
  }
}
